import EducatorSubscription from './EducatorSubscription';
import EducatorWeekPass from './EducatorWeekPass';
import ExplorerDayPass from './ExplorerDayPass';
import ExplorerSubscription from './ExplorerSubscription';
import { HabitatScopedProductType, isHabitatScoped, ProductType } from './ProductsPromptModal/redux/types';
import SingleHabitatDayPass from './SingleHabitatDayPass';
import SponsorshipSubscription from './SponsorshipSubscription';

/** The two habitat-scoped cards, once a habitat is known to exist. */
const renderHabitatCard = (productType: HabitatScopedProductType, habitatId: string, entryPoint: string | undefined) =>
  productType === 'single-habitat-day-pass' ? (
    <SingleHabitatDayPass habitatId={habitatId} entryPoint={entryPoint} />
  ) : (
    <SponsorshipSubscription habitatId={habitatId} entryPoint={entryPoint} />
  );

/**
 * Render the card for a product type. Shared by the products prompt modal and the Speedy Flow's
 * choose-product step, so the two offer the same thing in the same way.
 *
 * Habitat-scoped products render nothing without a habitat — an offer that cannot name what it
 * unlocks is worse than no offer.
 */
const renderProductCard = (
  productType: ProductType,
  habitatId: string | null | undefined,
  entryPoint: string | undefined,
  variant: 'primary' | 'secondary',
  forEducator?: boolean,
) => {
  // Asked once of `isHabitatScoped` rather than per case, so this and `rendersNothing` — which
  // refuses to open a step whose every card would be dropped here — cannot fall out of step.
  if (isHabitatScoped(productType)) {
    return habitatId ? renderHabitatCard(productType, habitatId, entryPoint) : null;
  }

  switch (productType) {
    case 'all-habitats-day-pass':
      return <ExplorerDayPass entryPoint={entryPoint} variant={variant} forEducator={forEducator} />;
    case 'educator-week-pass':
      return <EducatorWeekPass entryPoint={entryPoint} />;
    case 'explorer-pass':
      return <ExplorerSubscription entryPoint={entryPoint} />;
    case 'educator-pass':
      return <EducatorSubscription entryPoint={entryPoint} />;
    default:
      return null;
  }
};

export default renderProductCard;
